import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {FormBuilder} from '@angular/forms';
import {environment} from '../../../environments/environment';
import {HttpService} from '../../http-utility/http.service';
import {Observable} from 'rxjs';

@Injectable()
export class UsatiService extends HttpService {
  apiUrl: string = environment.apiUrl;
  url = 'usati/';

  constructor(protected http: HttpClient, protected fb: FormBuilder) {
    super(http);
  }


  creaFormGroup() {
    return this.fb.group({
      vclTipologia: [0],
      vclTestoLibero: [''],
      vclKmDa: [0],
      vclKmA: [0],
      vclAnnoDa: [0],
      vclAnnoA: [0],
      vclPotenzaNumKwDa: [0],
      vclPotenzaNumKwA: [0],
      vclPotenzaNumCvDa: [0],
      vclPotenzaNumCvA: [0],
      vclCilindrataNumDa: [0],
      vclCilindrataNumA: [0],
      vclPrezzoVenditaDa: [0],
      vclPrezzoVenditaA: [0],
      vclTrazione: [0]
    });
  }

  settaFormGroup(pratica) {
    return {
      vclTipologia: pratica.vclTipologia ? pratica.vclTipologia : '0',
      vclTestoLibero: '',
      vclKmDa: pratica.vclKmDa ? parseFloat(pratica.vclKmDa) : 0,
      vclKmA: pratica.vclKmA ? Number(pratica.vclKmA) : 0,
      vclAnnoDa: pratica.vclAnnoDa ? Number(pratica.vclAnnoDa) : 0,
      vclAnnoA: pratica.vclAnnoA ? Number(pratica.vclAnnoA) : 0,
      vclPotenzaNumKwDa: pratica.vclPotenzaNumKwDa ? pratica.vclPotenzaNumKwDa : 0,
      vclPotenzaNumKwA: pratica.vclPotenzaNumKwA ? pratica.vclPotenzaNumKwA : 0,
      vclPotenzaNumCvDa: pratica.vclPotenzaNumCvDa ? pratica.vclPotenzaNumCvDa : 0,
      vclPotenzaNumCvA: pratica.vclPotenzaNumCvA ? pratica.vclPotenzaNumCvA : 0,
      vclCilindrataNumDa: pratica.vclCilindrataNumDa ? pratica.vclCilindrataNumDa : 0,
      vclCilindrataNumA: pratica.vclCilindrataNumA ? pratica.vclCilindrataNumA : 0,
      vclPrezzoVenditaDa: pratica.vclPrezzoVenditaDa ? pratica.vclPrezzoVenditaDa : 0,
      vclPrezzoVenditaA: pratica.vclPrezzoVenditaA ? pratica.vclPrezzoVenditaA : 0,
      vclTrazione: pratica.vclTrazione ? pratica.vclTrazione : 0
    };
  }
}
